<template>
  <div class="kye-navbar noselect" :style="{left: `${paddingLeft}px`}">
    <span class="scroll-btn scroll-btn--left" @click="handleScrollLeft" v-show="isShowLeftBtn">
      <i class="el-icon-arrow-left" />
    </span>
    <div class="scroll-container" ref="scrollContainer" @wheel.prevent="handleScroll">
      <draggable
        ref="scrollWrapper"
        class="scroll-wrapper"
        :style="{left: `${left}px`}"
        :list="visitedViews"
        v-bind="dragOptions"
        @end="handleDragEnd">
        <a v-for="tag in visitedViews"
           :key="tag.tag"
           :class="tagClass(tag.tag)"
           :path="tag.path"
           ref="tags"
           @click="pushRoute(tag.path, tag.tag, false, true)"
           @contextmenu.prevent="openMenu(tag, $event)">
          <span>{{tag.title}}
            <i v-if="defaultOpenTags.includes(tag.tag)" class="layout layout-lock nav-lock-icon" />
          </span>
          <i v-if="tag.tag !== '/'" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)"></i>
        </a>
      </draggable>
    </div>
    <span class="scroll-btn scroll-btn--right" @click="handleScrollRight" v-show="isShowRightBtn">
      <i class="el-icon-arrow-right" />
    </span>
    <div style="position:absolute;bottom:0px;left:0px;width:100%">
      <ul class='contextmenu' v-show="visible" :style="{left: menuLeft}">
        <li v-show="!isLock" @click="setDefaultViews()">下次默认打开</li>
        <li  v-show="isLock" @click="setDefaultViews(true)">解锁</li>
        <li v-show="showClose" @click="closeSelectedTag(selectedTag)">关闭</li>
        <li v-show="showClose" @click="closeOthersTags">关闭其它</li>
        <li v-show="showClose" @click="closeAllTags">关闭全部</li>
        <li @click="openBlank">打开新窗口</li>
        <li @click="addHome(selectedTag)">添加到首页</li>
      </ul>
    </div>
    <a ref="href" rel="opener" hidden target="_blank" :href="`/#${selectedTag.path || '/'}`"></a>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import { checkAppraise } from './setup/check-appraise'
  import { QtReportChangeTab } from '@/layout/utils/report-qt.js'
  import DefaultOpenStore from './setup/default-open-tabs'
  // 标签宽度
  const TAG_WIDTH = 100
  // 滚动距离
  const SCROLL_UNIT = TAG_WIDTH * 3

  export default {
    name: 'navbar',
    components: { draggable },
    props: {
      paddingLeft: Number
    },
    data () {
      return {
        left: 0,
        menuLeft: '0px',
        visible: false,
        tag: '',
        selectedTag: {},
        dragOptions: {
          draggable: '.tag',
          handle: '.tag',
          animation: 150,
          ghostClass: 'kye-ghost'
        },
        isShowRightBtn: false,
        isShowLeftBtn: false
      }
    },
    mounted () {
      this.tag = this.$route.meta.tag
      this.viewsLen = this.visitedViews.length
      this.clientWidth = window.innerWidth

      window.addEventListener('keydown', this.keydownEvent)
    },
    beforeDestroy () {
      window.removeEventListener('keydown', this.keydownEvent)
    },
    computed: {
      visitedViews () {
        return this.$store.state.tagsView.visitedViews
      },
      showClose () {
        return this.selectedTag.tag !== '/'
      },
      defaultOpenTags () {
        return DefaultOpenStore.defaultOpenViews.map(v => v.tag)
      },
      isLock () {
        return this.defaultOpenTags.includes(this.selectedTag.tag)
      }
    },
    watch: {
      $route (val) {
        this.tag = val.meta.tag
        this.scrollIntoViewNarItem()
      },
      visible (value) {
        if (value) {
          document.body.addEventListener('click', this.closeMenu)
        } else {
          document.body.removeEventListener('click', this.closeMenu)
        }
      },
      visitedViews (val, oldVal) {
        // 新增路由执行路由页签定位逻辑，内部已执行更新逻辑，无需二次更新
        if (val.length < this.viewsLen) {
          this.updateScrollBtn()
        }
        this.viewsLen = val.length
      }
    },
    methods: {
      tagClass (tag) {
        return tag === this.tag ? 'tag is-active' : 'tag'
      },
      // user: 用户手动切换的该模块
      pushRoute (path, tag, keep, user) {
        // 从框架布局进入，添加入口标记
        const route = this.$router.resolve(path).route
        route.meta.layout = true
        this.$router.push(path)
        this.$bus.$emit('TAB_CLICK', path, tag, keep)
        user && QtReportChangeTab(path)
      },
      async closeSelectedTagEvent (tag) {
        await checkAppraise(tag, this.$route)
        this.$store.dispatch('delVisitedViews', tag).then(views => {
          if (tag.path === this.$route.fullPath) {
            if (views.length) {
              let view = views[views.length - 1]
              this.pushRoute(view.path, view.tag, true)
            } else {
              this.pushRoute('/', '/', true)
            }
          }
          if (this.defaultOpenTags.includes(tag.tag)) {
            // 关闭同时解锁页签
            DefaultOpenStore.setDefaultOpenTabs(true, tag, false)
          }
        })
      },
      closeSelectedTag (tag) {
        if (tag.closeTag) {
          // 当前页面未加载，内部js未执行监听
          const reloadRoutes = window.__ERP_reloadRoutes
          if (reloadRoutes[tag.tag]) {
            this.closeSelectedTagEvent(tag)
            return
          }
          // 用户需要监听关闭事件
          this.$bus.$emit('GLOBAL_CLOSE_TAG', tag, this.closeSelectedTagEvent)
        } else if (tag.path !== tag.tag && tag.pageType !== 'detail') {
          // 模块的新增、编辑页，提示保存数据
          this.$confirm(window.__ERPGLOABLECONFIG__.saveTips, '提示').then(_ => {
            this.closeSelectedTagEvent(tag)
          }).catch(console.log)
        } else {
          this.closeSelectedTagEvent(tag)
        }
      },
      async closeOthersTags () {
        try {
          await this.$confirm('您确定要关闭其它模块？', '提示')
          this.left = 0
          this.pushRoute(this.selectedTag.path, this.selectedTag.tag)
          this.$store.dispatch('delOthersViews', this.selectedTag)
          // 同时解锁其他页签
          DefaultOpenStore.unLockOtherTabs(this.selectedTag)
        } catch (e) {
          console.log(e)
        }
      },
      async closeAllTags () {
        try {
          await this.$confirm('您确定要关闭全部模块？', '提示')
          this.left = 0
          this.$store.dispatch('delAllViews')
          this.pushRoute('/', '/', true)
          // 同时解锁所有页签
          DefaultOpenStore.unLockAllTabs()
        } catch (e) {
        }
      },
      openMenu (tag, e) {
        this.visible = true
        this.selectedTag = tag
        let x = e.clientX
        if (x > this.clientWidth - 84) {
          x -= 84
        }
        this.menuLeft = `${x - this.paddingLeft - 20}px`
      },
      closeMenu () {
        this.visible = false
      },
      openBlank () {
        this.$refs.href.dispatchEvent(new MouseEvent('click'))
      },
      // 菜单添加到首页 常用模块
      async addHome (data) {
        try {
          // 获取 已添加到的常用模块
          const itemList = await this.getHomeIndexList()
          // 检查模块是否已经 存在
          if (itemList.some(v => v.url === data.path)) {
            this.$message.warning('此模块已存在')
            return false
          }
          const menuGroup = {
            moduleGroupId: 1,
            moduleGroupName: '未分组模块',
            moduleType: 10
          }
          // 菜单信息
          const menus = this.$store.getters.menus
          // 获取要添加的 菜单信息
          const obj = {
            icon: '',
            title: menus[data.path].title,
            url: data.path,
            ...menuGroup
          }
          itemList.unshift(obj)
          // 添加保存参数
          itemList.forEach((item, i) => {
            item.displaySequence = i + 1
            item.icon = ''
            item.moduleGroupId = '1'
            item.moduleGroupName = '未分组模块'
            item.moduleType = '10'
          })
          const addList = [obj]
          const params = { ...menuGroup, itemList, addList }
          console.log(params)
          await this.$http('system.homeIndex.save', params)
          this.$bus.$emit('GLOABL_HOME_UPDATE_MENU')
          this.$message.success('添加成功！')
        } catch (err) {
          console.log(err)
        }
      },
      // 获取 已添加到的常用模块
      async getHomeIndexList () {
        try {
          const res = await this.$http('system.homeModuleGroup.show', { moduleType: '10' }, false)
          const group = res.find(item => +item.defaultGroupFlag === 1)
          if (!group) {
            return []
          }
          const { itemList } = group
          return itemList
        } catch (e) {
          console.log(e)
        }
      },
      handleScroll (e) {
        this.container = this.container || this.$refs.scrollContainer
        this.wrapper = this.wrapper || this.$refs.scrollWrapper.$el
        const eventDelta = e.wheelDelta || -e.deltaY * 3
        if (eventDelta > 0) {
          this.left = Math.min(0, this.left + eventDelta)
        } else {
          const containerWidth = this.container.offsetWidth
          const wrapperWidth = this.wrapper.offsetWidth
          if (containerWidth < wrapperWidth) {
            if (this.left >= -(wrapperWidth - containerWidth)) {
              this.left = Math.max(this.left + eventDelta, containerWidth - wrapperWidth)
            }
          } else {
            this.left = 0
          }
        }
        this.updateScrollBtn()
      },
      handleScrollRight () {
        const { containerWidth, scrollWidth } = this.getWidth()
        if (-this.left + SCROLL_UNIT + containerWidth > scrollWidth) {
          this.left = containerWidth - scrollWidth
        } else {
          this.left = this.left - SCROLL_UNIT
        }
        this.updateScrollBtn()
      },
      handleScrollLeft () {
        this.left = this.left + SCROLL_UNIT >= 0 ? 0 : this.left + SCROLL_UNIT
        this.updateScrollBtn()
      },
      updateScrollBtn () {
        this.$nextTick(() => {
          const { containerWidth, scrollWidth } = this.getWidth()
          this.isShowLeftBtn = this.left !== 0
          this.isShowRightBtn = containerWidth - this.left < scrollWidth
        })
      },
      getWidth () {
        const scrollWidth = this.$refs.scrollWrapper.$el.getBoundingClientRect().width
        const containerWidth = this.$refs.scrollContainer.getBoundingClientRect().width

        return {
          containerWidth: Math.round(containerWidth),
          scrollWidth: Math.round(scrollWidth)
        }
      },
      scrollIntoViewNarItem () {
        try {
          clearTimeout(this._scrollIntoViewNarTimer)
          this._scrollIntoViewNarTimer = setTimeout(() => {
            this.$nextTick(() => {
              // const activeTagIndex = this.visitedViews.findIndex(v => v.tag === this.tag)
              const activeEl = this.$el.querySelector('.is-active')
              // 检查是否在可视区域内
              if (activeEl) {
                const activeElLeft = activeEl.offsetLeft
                const activeElRight = activeElLeft + activeEl.offsetWidth
                const containerWidth = this.$refs.scrollContainer.offsetWidth
                const isActiveElOutOfView = activeElLeft < -this.left | activeElRight > -this.left + containerWidth
                const allWidth = this.$refs.scrollWrapper.$el.offsetWidth - containerWidth
                if (isActiveElOutOfView) {
                  let _left = activeElLeft < -this.left ? -activeElLeft : -activeElRight + containerWidth / 2
                  if (_left < -allWidth) {
                    _left = -allWidth
                  }
                  this.left = _left
                }
                this.updateScrollBtn()
              }
            })
          }, 300)
        } catch (e) {
          console.error(e)
        }
      },
      // 设置 下次默认打开/解锁
      async setDefaultViews (isUnLock) {
        DefaultOpenStore.setDefaultOpenTabs(isUnLock, this.selectedTag)
      },
      // 拖动页签，同时设置默认页签顺序
      handleDragEnd () {
        const tagSort = this.visitedViews.map(tag => tag.tag)
        DefaultOpenStore.changeDefaultTabsOrder(tagSort)
      },
      keydownEvent (e) {
        // alt + 上下快捷键
        if (e.altKey && [38, 40].includes(e.keyCode)) {
          const isLeft = e.keyCode === 38
          const len = this.visitedViews.length
          const curIndex = this.visitedViews.findIndex(v => v.tag === this.tag)
          let nextIndex = curIndex === len - 1 ? 0 : curIndex + 1
          if (isLeft) {
            nextIndex = curIndex === 0 ? len - 1 : curIndex - 1
          }
          const nextTag = this.visitedViews[nextIndex]
          this.pushRoute(nextTag.path, nextTag.tag, false, true)
        }
      }
    }
  }
</script>

<style lang="scss">
  .kye-navbar {
    position: absolute;
    top: 50px;
    right: 0;
    padding: 0;
    background-color: #e8e8ed;
    display: flex;
    z-index: 100;
    .scroll-btn {
      line-height: 28px;
      display: block;
      box-sizing: border-box;
      width: 28px;
      height: 28px;
      text-align: center;
      background: #ffffff;
      cursor: pointer;
      border-radius: 4px;
      box-shadow: 0px 1px 10px 0px rgba(28, 30, 35, 0.05),0px 4px 5px 0px rgba(28, 30, 35, 0.08),0px 2px 4px -1px rgba(28, 30, 35, 0.12);
      z-index: 1;
      .el-icon-arrow-left,
      .el-icon-arrow-right {
        color: var(--g-color-primary)
      }
    }
    .scroll-container {
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      width: 100%;
      height: 28px;
      background-color: #e8e8ed;

      .scroll-wrapper {
        position: absolute;
        display: flex;
        height: 100%;
      }

      .tag {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        color: #333333;
        padding-left: 12px;
        padding-right: 10px;
        border-left: 1px solid #dbdae6;
        line-height: 28px;
        cursor: pointer;
        &:last-child {
          border-right: 1px solid #dbdae6;
        }
        &:hover {
          background-color: #f2f3f7;
        }
        span {
          padding-right: 16px;
          position: relative;
          .nav-lock-icon {
            width: 8px;
            position: absolute;
            top: 0px;
            right: 5px;
            font-size: 8px;
            font-weight: normal;
            color: #9D9CA4;
          }
        }
        .el-icon-close {
          height: 12px;
          cursor: pointer;
          color: #979797;
          -webkit-text-stroke-width: 0.8px;
          &:hover {
            color: #ffffff;
            background-color: #979797;
            border-radius: 50%;
          }
        }
      }
      .is-active {
        background-color: #ffffff;
      }
      .is-active span {
        color: var(--g-color-primary);
        font-weight: bold;
      }
    }

    .contextmenu {
      position: absolute;
      top: -10px;
      margin: 0;
      z-index: 100;
      padding: 4px 0;
      color: #333;
      font-size: 12px;
      font-weight: 400;
      background: #fff;
      border-radius: 4px;
      list-style-type: none;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
      li {
        margin: 0;
        padding: 7px 16px;
        margin: 4px 4px 0 4px;
        border-radius: 4px;
        cursor: pointer;
        &:hover {
          background: #f2effe;
        }
        &:active {
          color: var(--g-color-primary);
        }
        &:last-child {
          margin-bottom: 4px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/layout/navbar.vue